import { CSSProperties } from "react";

export interface TutorialStep {
    type: string;
    title: string;
    url: string | undefined; 
    subheading: string;
    id: string;
    status: boolean;
  }
  

export interface Headers {
  heading: string;
  subHeading: string;
}

export interface TutorialProps {
  heading: string;
  subheading: string;
  userId?: string;
  token?: string;
  questId: string;
  bgColor?: string;
  btnTextColor?: string;
  textColor?: string;
  font?: string;
  isOpen?: boolean;
  uniqueUserId?: string;
  uniqueEmailId?: string;
  iconColor?: string;
  onLinkTrigger?: (link: string) => void;
  Headers?: Headers[] | undefined;
  styleConfig?: TutorialStyleConfig;
  showFooter?: boolean;
  variation?: string;
}

export interface TutorialAction {
    actionType: string;
    title: string;
    metadata?: {
      link?: string;
    };
    description?: string;
    actionId: string;
    isCompleted: boolean;
  }

  export interface QuestResponse {
    success: boolean;
    data: {
      sdkConfig?: {
        uiProps?: {
          questThemeData?: PartialQuestThemeData;
          BrandTheme?: {
            properties: PartialBrandTheme;
          };
        };
      };
      actions: TutorialAction[];
      campaignVariationId: string;
    };
  }
  

export interface TutorialThemeConfig {
  backgroundColor?: string;
  primaryColor?: string;
  secondaryColor?: string;
  fontFamily?: string;
}

export interface TutorialStyleConfig {
  Form?: CSSProperties;
  Heading?: CSSProperties;
  Description?: CSSProperties;
  Topbar?: CSSProperties;
  Footer?: {
    FooterStyle?: CSSProperties;
    FooterTextStyle?: CSSProperties;
    FooterIcon?: CSSProperties;
    FooterText?: string;
    FooterLink?: string;
  };
}

export interface TutorialQuestThemeData {
    accentColor: string;
    theme: string;
    borderRadius: string;
    buttonColor: string;
    images: string[];
  }
  
  export interface TutorialBrandTheme {
    accentColor?: string;
    background?: string;
    borderRadius?: string;
    primaryButton?: string;
    secondaryButton?: string;
    contentColor?: string;
    fontFamily?: string;
    logo?: string;
    primaryColor?: string;
    secondaryColor?: string;
    tertiaryColor?: string;
    titleColor?: string;
  }
  
  // Define Partial types with full interface as base
  export type PartialQuestThemeData = Partial<TutorialQuestThemeData>;
  export type PartialBrandTheme = Partial<TutorialBrandTheme>;
  
  // Create default values
  export const DEFAULT_QUEST_THEME: PartialQuestThemeData = {
    accentColor: "",
    theme: "",
    borderRadius: "",
    buttonColor: "",
    images: []
  };
  
  export const DEFAULT_BRAND_THEME: PartialBrandTheme = {
    accentColor: "",
    background: "",
    borderRadius: "",
    primaryButton: "",
    contentColor: "",
    fontFamily: "",
    logo: "",
    primaryColor: "",
    secondaryColor: "",
    tertiaryColor: "",
    titleColor: ""
  };
